import { useContext } from 'react';
import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../shared/helpers/plural';
import { RouterContext } from '../../../contexts/RouterContext';
import CardBanner, { CardBannerVariant } from '../../generic/CardBanner/CardBanner';

type Props = {
  count: number;
  dependenciesUrl: string;
};

/**
 * Callout shown on the report page when the revision has unknown dependencies,
 * prompting the user to classify them through the Manual Dependencies flow.
 */
export const UnknownDependenciesBanner: VoidFunctionComponent<Props> = ({ count, dependenciesUrl }) => {
  const { getRouter } = useContext(RouterContext);
  return (
    <CardBanner
      variant={CardBannerVariant.WARNING}
      title={`${count} Unknown ${plural(count, 'Dependency', 'Dependencies')} in this Project`}
      description="They won't be correctly classified in your reports until resolved. Classifying them improves accuracy across licensing, security, and compliance results."
      cta={{
        text: 'Resolve Manual Deps \u{276F}',
        onClick: () => getRouter().push(dependenciesUrl),
        isFullWidth: true,
      }}
    />
  );
};
